module.exports = __webpack_public_path__ + "img/Presets.6f78e093.gif";